var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.youtube)?_c('x-youtube-player',{attrs:{"videoID":_vm.src,"startTime":_vm.startTime,"endTime":_vm.endTime}}):_c('x-video-player',{attrs:{"src":_vm.src,"showControls":_vm.showControls,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }